export const environment = {
  name: 'development',
  production: false,
  apiBaseUrl: 'https://dev.srishti-marketing-ai.t-systems.net/marketing/api/v1',
  msalConfig: {
    auth: {
      clientId: 'f0986d5c-19fd-470e-bc1e-864e94501aef',
      authority: 'https://login.microsoftonline.com/a5e6c6bd-17f0-4980-be25-49bcd5c558ae',
      redirectUri: 'https://dev.srishti-marketing-ai.t-systems.net',
      postLogoutRedirectUri: 'https://dev.srishti-marketing-ai.t-systems.net/login',
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
      },
    },
    apiConfig: {
      scopes: ['api://marketing-backend/roles'],
      uri: 'https://dev.srishti-marketing-ai.t-systems.net/marketing/api/v1',
    },
  },
};